import api from "../network/apiConfig";

function errorGenerator(error) {
  const info = {};

  if (error?.response) {
    Object.assign(info, {
      data: error.response.data,
      error: error.response.status,
    });
  } else {
    Object.assign(info, {
      data: { message: "Something went wrong" },
      error: "Bad Network",
    });
  }

  return info;
}

/**
 * Authenticate with Azure AD
 * @param {Object} tokenResponse - The token response from MSAL
 * @param {string} email - The email address from MSAL
 * @returns {Object} Login response from backend
 */
export const loginWithAzure = async (tokenResponse, email) => {
  try {
    const result = await api.post("/azure/token", {
      id_token: tokenResponse.idToken,
      access_token: tokenResponse.accessToken,
      email: email,
    });

    if (result.status === 200 && result.data && result.data.access_token) {
      return { data: result.data, error: null };
    }
    return errorGenerator({});
  } catch (error) {
    return errorGenerator(error);
  }
};
